exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noInclTable mat-row mat-cell:last-of-type {\n  text-align: end; }\n\n.noInclTable mat-header-cell:last-of-type,\n.noInclTable mat-cell:last-of-type {\n  -ms-flex-positive: 0.5;\n      flex-grow: 0.5; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/editar-aspecto/editar-aspecto.component.scss
// module id = ../../../../../src/app/editar-aspecto/editar-aspecto.component.scss
// module chunks = main